export default __webpack_public_path__ + "static/media/tdep.883876f5.png";